document.addEventListener("DOMContentLoaded", function() {
  setTimeout(() => {
    const productForm = document.querySelector("product-form");
    if (!productForm) return;

    if (typeof BSS_B2B !== "undefined" && BSS_B2B.page?.isProductPage()) {
        productForm.setAttribute("bss-b2b-main-product-form", "");
    } else {
        productForm.setAttribute("bss-b2b-quickview-product-form", "");
    }
  }, 500);

  document.body.addEventListener('click', function (e) {
    const quickViewBtn = e.target.closest('[bss-b2b-btn-quickview]');
    if (quickViewBtn) {
      setTimeout(() => {
        const productForm = document.querySelector("product-form");
        if (!productForm) return;

        productForm.setAttribute("bss-b2b-quickview-product-form", "");
        document.dispatchEvent(new Event('bss_b2b:QuickviewLoaded'));
      }, 2000);
    }
  });

  document.querySelectorAll(".bss-b2b-qb-table").forEach(function (table) {
    const cartItem = table.closest(".cart-item");
    if (!cartItem) return;

    const descCol = cartItem.querySelector(".cart-item__column.cart-item__description");
    if (!descCol) return;

    descCol.appendChild(table);
  });
});
